import { Suspense, lazy, useState } from "react";
import { MessageCircle } from "lucide-react";
import { trackChatEvent } from "@/lib/chat-tracking";

/** One-line rollback switch for the whole chatbot feature. */
export const CHATBOT_ENABLED = true;

/**
 * The launcher is intentionally tiny: nothing but this button ships in the
 * initial bundle. The chat UI, its state, and the AI call path are only
 * downloaded when the visitor clicks.
 */
const ChatPanel = lazy(() => import("./ChatPanel"));

export function ChatLauncher() {
  const [loaded, setLoaded] = useState(false);
  const [open, setOpen] = useState(false);

  if (!CHATBOT_ENABLED) return null;

  return (
    <>
      {/* Fixed-size button reserved from first paint — zero layout shift. */}
      <button
        type="button"
        onClick={() => {
          trackChatEvent("chat_opened");
          setLoaded(true);
          setOpen(true);
        }}
        aria-expanded={open}
        className="fixed bottom-5 right-5 z-40 hidden h-12 w-[212px] items-center justify-center gap-2 rounded-full bg-primary px-4 text-[14px] font-semibold text-white shadow-lg transition-colors hover:bg-[var(--primary-hover)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent lg:flex"
      >
        <MessageCircle className="h-4 w-4" aria-hidden="true" />
        Ask Durafoam Roofing
      </button>


      {loaded && (
        <Suspense fallback={null}>
          <ChatPanel open={open} onClose={() => setOpen(false)} />
        </Suspense>
      )}
    </>
  );
}
